// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale/lang/en'
import {
  Button,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Notification,
  Input,
  Form,
  FormItem,
  Carousel,
  CarouselItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Row,
  Col,
  Popover,
  Card,
  Dialog,
  InputNumber,
  Breadcrumb,
  BreadcrumbItem,
  Pagination,
  Tabs,
  TabPane,
  Radio,
  RadioGroup,
  RadioButton,
  Table,
  TableColumn,
  Badge,
  Select,
  Collapse,
  CollapseItem
} from 'element-ui'
// 按需引入部分组件
import MintUi from 'mint-ui'
import App from './App'
import routes from './router'
import store from './store/state'
import * as customFilters from './filters/index'
import 'mint-ui/lib/style.css'
import LangEn from './locales/en'
import LangZh from './locales/zh'
import dateFormats from './locales/dateFormats'
import './style/common.css'
import { checkCampaign } from './service/index'
import * as directive from './directive/index'
// import vuescroll from 'vuescroll/dist/vuescroll-slide';
// import 'vuescroll/dist/vuescroll.css';

Vue.use(VueI18n)
Vue.use({ locale })
Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Loading.directive)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Popover)
Vue.use(Card)
Vue.use(Dialog)
Vue.use(InputNumber)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Badge)
Vue.use(Select)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
// Vue.use(vuescroll);

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.config.productionTip = false

Vue.use(MintUi)
Vue.use(VueRouter)
const i18n = new VueI18n({
  locale: 'zh', // 语言标识
  messages: {
    en: LangEn,
    zh: LangZh
  },
  dateTimeFormats: dateFormats
})
Object.keys(directive).forEach(
  key => {
    Vue.directive(key, directive[key])
  }
)
const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
        window.scrollTo(savedPosition.x, savedPosition.y)
    } else {
      return { x: 0, y: 0 }
    }
  }
})
async function getCampaignInfo (camId, next) {
  console.log('camId',camId)
  const responseCampaign = await checkCampaign(camId)
  if (responseCampaign.status == -12) {
    next('/countdown?cid=' + camId)
  } else if (responseCampaign.status == -13) {
    next('/end?cid=' + camId)
  } else {
    next()
  }
}
// campaign时间判断
router.beforeEach((to, from, next) => {
  let cid = to.query.cid && typeof(to.query.cid)!='undefined' ? to.query.cid : -1
  if (
    to.name != undefined && ( 
    to.name == 'home' ||
    to.name == 'goodDetail' ||
    to.name == 'cart' ||
    to.name == 'cartmb' ||
    to.name == 'cat')
  ) {
    if (from.query.cid !== to.query.cid || from.query.refresh === 1) {
      store.commit('CLEAR_GOODS')
    }
    getCampaignInfo(cid, next, true) 
  } else {
    next()
  }
})

Vue.router = router
// 绑定过滤器
Object.keys(customFilters).forEach(key => {
  Vue.filter(key, customFilters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js